module.exports = __webpack_public_path__ + "static/assets/75530645e4af177c82c6afff2bf3f7a8.png";